import React from 'react';

import { Money, formatMoney } from '@betterment/core';
import { Box, Card, Heading, Separator, Text } from '@betterment/samba-react';

import { TaxLossHarvestingPerformanceModal } from '../../../../Shared/components-v2/tax-loss-harvesting/TaxLossHarvestingPerformanceModal';
import { TaxLossHarvestingToggletip } from '../../../../Shared/components-v2/tax-loss-harvesting/TaxLossHarvestingToggletip';

interface Props {
  allTimeTaxSavings?: Money;
  taxLossesHarvested?: Money;
}

export const TaxSavingsEnabledCard: React.FC<Props> = ({ allTimeTaxSavings, taxLossesHarvested }) => {
  return (
    <Card>
      <Card.Header css={{ padding: 'space.300' }}>
        <Heading as="h2" variant="title200">
          Tax savings
        </Heading>
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content css={{ padding: 'space.300', display: 'flex', flexDirection: 'column', gap: 'space.100' }}>
        {allTimeTaxSavings && (
          <Box css={{ display: 'flex', flexDirection: 'column' }}>
            <Text>Estimated taxes saved</Text>
            <Text variant="text300" css={{ color: 'text.success' }}>
              {formatMoney(allTimeTaxSavings)}
            </Text>
          </Box>
        )}
        {taxLossesHarvested && (
          <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>
              Tax losses harvested
              <TaxLossHarvestingToggletip isEnabled={true} />
            </Text>
            <Text>{formatMoney(taxLossesHarvested)}</Text>
          </Box>
        )}
        {!allTimeTaxSavings && (
          <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>
              Tax losses harvesting
              <TaxLossHarvestingToggletip isEnabled={true} />
            </Text>
            <Text>Active</Text>
          </Box>
        )}
      </Card.Content>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Footer css={{ padding: 'space.300' }}>
        <TaxLossHarvestingPerformanceModal />
      </Card.Footer>
    </Card>
  );
};
